import { Link } from "react-router-dom";
import { Phone, WhatsappLogo, MapPin } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="border-t border-[#E8E5DF] bg-[#1E3F33] text-[#F9F6F0] mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-display font-bold text-2xl">ALLO DAKAR</div>
          <p className="text-[#C8D5CE] text-sm mt-2 max-w-xs">Transport confortable & sécurisé entre Saint-Louis et Dakar. Réservez en quelques secondes.</p>
        </div>
        <div>
          <div className="overline text-[#E69C24]">Contact</div>
          <ul className="mt-3 space-y-2 text-sm text-[#C8D5CE]">
            <li className="flex items-center gap-2"><Phone size={16}/> +221 77 235 50 48</li>
            <li className="flex items-center gap-2"><WhatsappLogo size={16}/> WhatsApp 24/7</li>
            <li className="flex items-center gap-2"><MapPin size={16}/> Saint-Louis · Dakar</li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#E69C24]">Paiements acceptés</div>
          <div className="mt-3 flex flex-wrap gap-2">
            <span className="px-3 py-1.5 rounded-full bg-white/10 text-sm">Cash</span>
            <span className="px-3 py-1.5 rounded-full bg-white/10 text-sm">Wave</span>
            <span className="px-3 py-1.5 rounded-full bg-white/10 text-sm">Orange Money</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-[#9DAFA8] flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 px-4">
        <span>© {new Date().getFullYear()} ALLO DAKAR · Tous droits réservés</span>
        <span className="hidden sm:inline">·</span>
        <Link to="/confidentialite" className="hover:text-white underline-offset-2 hover:underline" data-testid="footer-privacy-link">Politique de confidentialité</Link>
        <span className="hidden sm:inline">·</span>
        <Link to="/conditions" className="hover:text-white underline-offset-2 hover:underline" data-testid="footer-terms-link">Conditions d'utilisation</Link>
      </div>
    </footer>
  );
}
